import { useStore } from '@/store/useStore';
import { ordinal } from '@/ui/lib/utils';

export const useBetOnRacer = () => {
    const racers = useStore((state) => state.activeHeroes);
    const selectedRacer = useStore((state) => state.betOnRacer);

    if (!selectedRacer) {
        return null;
    }

    const racer = racers.find((racer) => racer.name === selectedRacer);

    if (!racer) {
        return null;
    }

    return {
        position: ordinal(racer.position),
        time: racer.time ?? '00:00:00',
        racerId: racer.name,
        multiplier: racer.multiplier,
    };
};
